// removed by extract-text-webpack-plugin
module.exports = {"minMaxComponent":"_2GXBoDVf59M3HzF3_Ryk_Q","control":"qoBDOisuxT06ye6WJ4Qno","inFilters":"Ur_Bcc3zOZV7ROEt-foge","managePrice":"_1qEA0u3pbFAlHBjWQrhAfF","lineFiltersPrice":"_1bD_cTCUw79YGki8bM2TvX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MinMaxPrices/MinMaxPrices.scss
// module id = 1635
// module chunks = 0